module.exports = __webpack_public_path__ + "static/media/other-landscape.dc60605a.jpg";